import { render, staticRenderFns } from "./Puzzles.vue?vue&type=template&id=21c59219&scoped=true"
import script from "./Puzzles.vue?vue&type=script&lang=js"
export * from "./Puzzles.vue?vue&type=script&lang=js"
import style0 from "./Puzzles.vue?vue&type=style&index=0&id=21c59219&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c59219",
  null
  
)

export default component.exports